export enum ResidueHighlightFormat {
  MUTATION = 'MUTATION',
  UNKNOWN = 'UNKNOWN',
}

export interface PDFExportResidue {
  letter: string; // Amino acids or DNA bases
  format: ResidueHighlightFormat | null;
}

export type PDFExportResidues = Array<PDFExportResidue>;

export enum CDRAnnotationName {
  'FRAMEWORK' = 'FRAMEWORK',
  'CDR' = 'CDR',
}
export interface PDFExportCDRAnnotation {
  name: CDRAnnotationName;
  range: {start: number; end: number};
}
export interface PDFExportRawSequence {
  sequenceName: string;
  residues: PDFExportResidues;
  cdrAnnotations?: Array<PDFExportCDRAnnotation>;
}

export type PDFExportRawSequences = Array<PDFExportRawSequence>;

export interface PDFExportRawData {
  alignmentName: string;
  sequences: PDFExportRawSequences;
}

export interface Block {
  rows: PDFExportRawSequences;
}

export interface Highlight {
  index: number;
  color: string;
  length?: number;
}

export interface Underline {
  index: number;
  color: string;
  length?: number;
}

export interface Line {
  text: string;
  highlights: Array<Highlight>;
  underlines: Array<Underline>;
}

export interface Page {
  lines: Array<Line>;
}

export interface AlignmentPages {
  pages: Array<Page>;
}

export interface PageSize {
  charactersPerLine: number;
  linesPerPage: number;
}

// Numbers obtained empirically by testing with given margin & font size
export const LETTER: PageSize = {
  charactersPerLine: 95,
  linesPerPage: 71,
};

export const LANDSCAPE: PageSize = {
  charactersPerLine: 125,
  linesPerPage: 54,
};
